import { fileTypes, IPresignedUrlsResponse } from "src/pages/Studies/models/interfaces";
import { apiService } from "../../../services";
import { generateFileName } from "src/pages/Studies/transformer";
import { CompletionData } from "../models/interfaces";

export const getAllTaxonomy = async (include_entities: boolean) => {
	return await apiService.get("/taxonomy/", { include_entities });
};

export const getTaxonomyDetails = async (taxonomy_id: string) => {
	return await apiService.get("/taxonomy/detail", { taxonomy_id });
};

export const addTaxonomy = async (details) => {
	return await apiService.post("/taxonomy/create", details);
};

export const updateTaxonomy = async (details) => {
	return await apiService.put("/taxonomy/", details);
};

export const updateBasicTaxonomyDetails = async (details) => {
	return await apiService.put("/taxonomy/basic", details);
};

export const deleteTaxonomy = async (taxonomy_id: string) => {
	return await apiService.delete("/taxonomy/", { taxonomy_id });
};

export const disableTaxonomy = async (details) => {
	return await apiService.put("/taxonomy/disable", details);
};

export const downloadFile = async () => {
	const fileName = generateFileName(fileTypes.addTaxonomy, "");
	try {
		const response: { presigned_url: string } = await apiService.get("/taxonomy/download_file");
		if (!response?.presigned_url) {
			throw new Error("Presigned URL is undefined.");
		}
		const fileResponse = await fetch(response?.presigned_url);
		if (!fileResponse.ok) {
			throw new Error(`Failed to download file. Status: ${fileResponse.status}`);
		}
		const blob = await fileResponse.blob();
		const url = window.URL.createObjectURL(blob);
		const a = document.createElement("a");
		a.href = url;
		a.download = fileName;
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
		window.URL.revokeObjectURL(url);
	} catch (err) {
		console.error("Error downloading file:", err);
		throw err;
	}
};

export const getPresignedUrl = async (payload): Promise<IPresignedUrlsResponse> => {
	return await apiService.post("/taxonomy/initiate_upload", payload);
};

export const completeUpload = async (payload: CompletionData) => {
	return await apiService.post("/taxonomy/complete_upload", payload);
};
